import { Navigate, useParams } from "react-router-dom";
import { NotFound } from "src/pages/ErrorBoundary/widgets/NotFound";

import { useKnowledgeBaseOutletContext } from "./useKnowledgeBaseOutletContext";
import { findKBArticleLocation } from "./utils";

export const KnowledgeBaseFallbackRoute = () => {
  const { basePath, tree } = useKnowledgeBaseOutletContext();
  const { "*": unmatchedPath = "" } = useParams();

  const requestedSlug = unmatchedPath.split("/").filter(Boolean).pop() ?? "";
  const location = findKBArticleLocation(tree, requestedSlug);

  if (!location) {
    return <NotFound />;
  }

  return (
    <Navigate
      to={`${basePath}/${location.sectionSlug}/${location.docSlug}`}
      replace
    />
  );
};
